import { FC } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import styles from './DatePicker.module.css';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import { SxProps, Theme, Typography, FormControl } from '@mui/material';

interface DatePickerProps {
  name: string;
  label?: string;
  description?: string;
  sx?: SxProps<Theme>
}

const DatePicker: FC<DatePickerProps> = ({ name, label, description, sx = [] }) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      defaultValue=""
      control={control}
      render={({ field, fieldState }) => (
        <FormControl
          sx={{ minWidth: '225px', width: "100%", '& *': { flex: 'unset'} }}
          className={styles.SelectWrapper}>
          <Typography variant="primaryFont">
            {label}
          </Typography>
          <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='en-us'>
            <MuiDatePicker
              sx={[
                (theme) => ({
                  minWidth: '225px',
                  marginTop: '4px',
                  backgroundColor: 'white',
                  "& .MuiPickersOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: theme.colors.primary,
                      borderWidth: '2px'
                    },
                    "& .Mui-error": {
                      borderColor: 'blue'
                    }
                  }
                }),
                ...(Array.isArray(sx) ? sx : [sx])
              ]}
              value={field.value ? moment.utc(field.value, 'MM/DD/YYYY') : null}
              onChange={(momentDate: any) => {
                const formattedDate = moment(momentDate).format('MM/DD/YYYY')
                field.onChange(formattedDate)
              }}
            />
          </LocalizationProvider>
          <Typography variant="errorFont">
            {fieldState.error?.message}
          </Typography>
          {description &&
            <Typography>{description}</Typography>
          }
        </FormControl>
      )}
    />
  )
};

export default DatePicker;
